import { Box, Button, Text } from '@grupoboticario/flora-react';
import React from 'react';
import { IProduct } from 'src/common/types/CatalogType';
import ProductPrice from '../ProductPrice';
import Styled from './ProductListItemStyle';

import { isReseller } from 'src/services/catalogService';

interface IProductListItem {
  product: IProduct;
  onSelectProduct: (product: IProduct) => void;
}

const ProductListItem: React.FC<IProductListItem> = ({
  product,
  onSelectProduct,
}) => {
  const testId = `product-list-item-${product.sku}`;

  return (
    <Styled.Wrapper data-testid={testId}>
      <Styled.Image>
        {!!product.images && <img aria-hidden="true" src={product.images[0]} />}
        <Text
          aria-label={`Código do S K U ${product.sku}`}
          variant="primary"
          size="auxiliarMini"
          color="$medium-light-1"
        >
          {product.sku}
        </Text>
      </Styled.Image>
      <Styled.Box>
        <Text variant="primary" size="auxiliarSmall" color="$medium-light-1">
          {product.name}
        </Text>
        {!isReseller() && (
          <ProductPrice
            price={product.price}
            discountPrice={product.discountPrice}
          ></ProductPrice>
        )}
      </Styled.Box>
      <Box css={{ display: 'flex', alignItems: 'center' }}>
        <Button
          variant="ghost"
          color="standard"
          size="small"
          aria-label={`Ver detalhes do produto ${product.name}`}
          onClick={() => onSelectProduct(product)}
          data-testid={`product-list-item-cta-${product.sku}`}
        >
          Detalhes
        </Button>
      </Box>
    </Styled.Wrapper>
  );
};

export default ProductListItem;
